import React, { useState } from "react";

const FAQS = [
  {
    title: (
      <>
        <span style={{ marginRight: 10, display: 'inline-flex', alignItems: 'center' }}>
          {/* Truck icon */}
          <svg width="22" height="22" fill="none" stroke="#C21833" strokeWidth="2" viewBox="0 0 24 24"><rect x="1" y="3" width="15" height="13" rx="2"/><path d="M16 8h3.17a2 2 0 0 1 1.66.89l2.58 3.87A2 2 0 0 1 23 14.13V16a2 2 0 0 1-2 2h-1"/><circle cx="5.5" cy="18.5" r="1.5"/><circle cx="18.5" cy="18.5" r="1.5"/></svg>
        </span>
        Shipping Policy
      </>
    ),
    content: (
      <div>
        We ensure safe, 6-8 working days delivery with trusted couriers. We provide free shipping on orders above <b>₹500</b> (within India).
      </div>
    )
  },
  {
    title: (
      <>
        <span style={{ marginRight: 10, display: 'inline-flex', alignItems: 'center' }}>
          {/* INR icon */}
          <svg width="22" height="22" fill="none" stroke="#C21833" strokeWidth="2" viewBox="0 0 24 24"><text x="4" y="19" fontSize="18" fontFamily="Arial" fill="#C21833">₹</text></svg>
        </span>
        Payment Policy
      </>
    ),
    content: (
      <div>
        We accept payments via <b>UPI</b> and <b>net banking</b>. <span style={{ color: '#C21833', fontWeight: 600 }}>Cash on Delivery is not available.</span>
      </div>
    )
  },
  {
    title: (
      <>
        <span style={{ marginRight: 10, display: 'inline-flex', alignItems: 'center' }}>
          {/* Refresh/Return icon */}
          <svg width="22" height="22" fill="none" stroke="#C21833" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
        </span>
        Return & Refund Policy
      </>
    ),
    content: (
      <div>
        <div style={{ marginBottom: 8 }}><b>Cherry on top adheres to a strict <span style={{ color: '#C21833' }}>NO RETURN and NO REFUND POLICY</span>.</b></div>
        <ul style={{ margin: '0 0 8px 18px', color: '#4a5568', paddingLeft:"10px" }}>
          <li>All sales final: No returns, exchanges, or refunds.</li>
          <li>Pre-order checks: Verify product details before placing order.</li>
          <li>Quality guarantee: Products are as described.</li>
        </ul>
        <div style={{ marginBottom: 8 }}>
          In case of damaged/wrong product, an <b>unpacking video from opening the seal of the parcel till the end without any cuts</b> will be required within <b>12 hrs</b> of it being delivered. No query will be entertained without the video.
        </div>
        <div>
          However, if you still find an issue with the product, you can mail us at <b style={{ color: '#C21833' }}>ontopcherry2025@gmail.com</b> along with the details of your complaint. Our customer care team will handle the complaint accordingly.
        </div>
      </div>
    )
  }
];

const styles = {
  page: {
    maxWidth: "100%",
    margin: "40px auto 60px auto",
    padding: "20px 12px"
  },
  title: {
    fontSize: 28,
    fontWeight: 600,
    color: "#C21833",
    marginBottom: 24,
    textAlign: "center"
  },
  accordion: {
    background: "#fff",
    borderRadius: 12,
    boxShadow: "0 2px 12px rgba(201,161,74,0.07)",
    marginBottom: 18,
    overflow: "hidden"
  },
  accordionTitle: {
    display: "flex",
    alignItems: "center",
    fontSize: 18,
    fontWeight: 600,
    color: "#2d3748",
    padding: "18px 18px 18px 18px",
    cursor: "pointer",
    borderBottom: "1px solid #f0e6e6",
    background: "#f7f0e8"
  },
  accordionContent: {
    padding: "18px 18px 18px 38px",
    color: "#4a5568",
    fontSize: 15,
    background: "#fff"
  }
};

export default function FAQPage() {
  const [open, setOpen] = useState(null);
  return (
    <div style={styles.page}>
      <div style={styles.title}>Frequently Asked Questions</div>
      {FAQS.map((faq, i) => (
        <div key={i} style={styles.accordion}>
          <div
            style={styles.accordionTitle}
            onClick={() => setOpen(open === i ? null : i)}
          >
            {faq.title}
            <span style={{ marginLeft: "auto", color: open === i ? "#C21833" : "#aaa", fontSize: 22, transition: "color 0.2s" }}>
              {open === i ? "−" : "+"}
            </span>
          </div>
          {open === i && (
            <div style={styles.accordionContent}>{faq.content}</div>
          )}
        </div>
      ))}
    </div>
  );
}
